var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map"},[_c('gmap-map',{ref:"mapRef",staticStyle:{"width":"100%","height":"400px"},attrs:{"zoom":10,"center":_vm.center,"options":{
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUI: false
      }}},[_c('gmap-marker',{attrs:{"position":_vm.center,"clickable":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }